import React,{useEffect,useState} from 'react';
import { Row, Col } from 'antd';
import DeviceStatusLightWrapper from './DeviceStatusLight.styles';

const DeviceStatusLight = (props) => {

  return (
    <DeviceStatusLightWrapper className="traffic-light-wrap" onClick={props.onClick}>
      <div className="border-box">
        <div className="border-box-inner">
        <Row gutter={10}>
          <Col xs={{span: 8}} md={{span: 8}}>
            <div className={"circle-light-color "+(props.color === 'red' ? 'red' : '')}></div>
          </Col> 
          <Col xs={{span: 8}} md={{span: 8}}>
            <div className={"circle-light-color "+(props.color === 'yellow' ? 'yellow' : '')}></div>
          </Col>  
          <Col xs={{span: 8}} md={{span: 8}}>
            <div className={"circle-light-color "+(props.color === 'green' ? 'green' : '')}></div>
          </Col>  
        </Row>
        </div>
      </div>
    </DeviceStatusLightWrapper>
  );
}

export default DeviceStatusLight;
